<template>
  <div class="d-flex flex-column align-items-center justify-content-center">
    <img src="/spinner.gif" alt="Loading" class="mb-2"/>
    <span class="text-grey" v-text="`${text}...`"/>
  </div>
</template>

<script>
export default {
  name: "Loader",
  props: {
    text: {
      type: String,
      required: false,
      default: ''
    }
  }
}
</script>
